import { render, staticRenderFns } from "./CreateProductMapping.vue?vue&type=template&id=b36f2882"
import script from "./CreateProductMapping.vue?vue&type=script&lang=js"
export * from "./CreateProductMapping.vue?vue&type=script&lang=js"
import style0 from "./CreateProductMapping.vue?vue&type=style&index=0&id=b36f2882&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports